export default __webpack_public_path__ + "static/media/IraLippkeStudios_Lina_Shteyn_BarDivEng-038.e6259171.jpg";